import { Colleague } from '../../store/types/colleague.type'
import { ColleagueRow } from '../colleague-row/colleague-row.component'

interface ColleaguesListProps {
  colleagues: Colleague[]
}

export function ColleaguesList({ colleagues }: ColleaguesListProps) {
  return (
    <div className='divide-y divide-slate-300 h-80'>
      {colleagues.map((colleague, index) => (
        <ColleagueRow key={colleague.id} colleague={colleague} index={index} />
      ))}
    </div>
  )
}
